import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import FeaturedSection from "./components/FeaturedSection";
import NewsSection from "./components/NewsSection";
import SpecialSection from "./components/SpecialSection";
import IntroSection from "./components/IntroSection";

export default function Home() {
  useSeo({
    title: "缘之空 - 高清电影电视剧资讯与剧情介绍平台",
    description:
      "缘之空网站为您提供丰富的电影电视剧资讯、剧情介绍和影视资源推荐，涵盖多种类型，助您轻松掌握最新影视动态。",
    keywords: "缘之空,影视资讯,电影剧情,电视剧介绍,影视资源,影视推荐,最新影视,剧情解析",
  });

  return (
    <div className="w-full">
      <h1 className="sr-only">缘之空 - 高清电影电视剧资讯与剧情介绍平台</h1>
      <HeroCarousel />
      <CategoryEntry />
      <FeaturedSection />
      <NewsSection />
      <SpecialSection />
      <IntroSection />
    </div>
  );
}